export const CreateState = Object.freeze({
	LOADING: 'loading',
	SUCCESS: 'success',
	ERROR: 'error',
	IDLE: 'idle',
});
